var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"Box"},[_c('div',{staticClass:"contentBox",class:_vm.type === 'success'
          ? 'success'
          : _vm.type === 'error'
          ? 'error'
          : _vm.type === 'info'
          ? 'info'
          : 'success',on:{"click":_vm.btnClick}},[(_vm.type === 'success')?_c('i',{staticClass:"el-icon-success icon"}):_vm._e(),(_vm.type === 'error')?_c('i',{staticClass:"el-icon-warning icon"}):_vm._e(),(_vm.type === 'info')?_c('i',{staticClass:"el-icon-error icon"}):_vm._e(),_c('div',{class:_vm.msg.length>6?'font16':''},[_vm._v(_vm._s(_vm.msg))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }